import { Box, Divider, FormLabel, Grid, Stack, Typography } from '@mui/material';

import { PercentageCounter } from 'src/components/FormikComponents/PercentageCounter';
import { NPICurrencyInput } from 'src/components/inputs/NPICurrencyInput';
import MainCard from 'src/components/MainCard/MainCard';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { isApplicationEditable } from 'src/pages/MerchantApplicationPage/merchantApplicationHelpers.util';

const CardTurnoverForm = ({ values, errors, touched, setFieldValue, setFieldTouched }) => {
    const { merchantApplication } = useAddMerchantContext();
    const isEditingDisabled = isApplicationEditable(merchantApplication);

    return (
        <MainCard>
            <Typography fontSize="24px" color="#575757" marginBottom="8px">
                Card Turnover
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />
            <Box display="flex" gap="24px" flexDirection="column">
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <Stack spacing={1}>
                            <Stack
                                direction="row"
                                spacing={2}
                                alignItems="flex-start"
                                justifyContent="space-between"
                            >
                                <FormLabel
                                    id="creditCardTurnover"
                                    sx={{ color: '#1D1D1B', fontSize: '14px', fontWeight: 600 }}
                                >
                                    Credit Card Turnover
                                </FormLabel>
                                <Stack spacing={0.5} style={{ width: '200px', minWidth: '200px' }}>
                                    <NPICurrencyInput
                                        onBlur={() => {
                                            return setFieldTouched('creditCardTurnover', true);
                                        }}
                                        name="creditCardTurnover"
                                        handleValue={(countInCents) => {
                                            if (countInCents !== values?.creditCardTurnover) {
                                                setFieldValue('creditCardTurnover', countInCents);
                                            }
                                        }}
                                        defaultValueInCents={values?.creditCardTurnover || 0}
                                        error={
                                            touched?.creditCardTurnover &&
                                            errors?.creditCardTurnover
                                        }
                                        disabled={isEditingDisabled}
                                        style={{ width: '100%' }}
                                        country={merchantApplication?.partner?.countryDetails}
                                    />
                                    {touched?.creditCardTurnover && errors?.creditCardTurnover && (
                                        <label className="error">{errors.creditCardTurnover}</label>
                                    )}
                                </Stack>
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="flex-start"
                            justifyContent="space-between"
                        >
                            <FormLabel
                                id="totalCardTurnover"
                                sx={{ color: '#1D1D1B', fontSize: '14px', fontWeight: 600 }}
                            >
                                Total Card Turnover
                            </FormLabel>
                            <Stack spacing={0.5} style={{ width: '200px', minWidth: '200px' }}>
                                <NPICurrencyInput
                                    onBlur={() => {
                                        return setFieldTouched('totalCardTurnover', true);
                                    }}
                                    name="totalCardTurnover"
                                    handleValue={(countInCents) => {
                                        if (countInCents !== values?.totalCardTurnover) {
                                            setFieldValue('totalCardTurnover', countInCents);
                                        }
                                    }}
                                    defaultValueInCents={values?.totalCardTurnover || 0}
                                    error={touched?.totalCardTurnover && errors?.totalCardTurnover}
                                    disabled={isEditingDisabled}
                                    style={{ width: '200px', minWidth: '200px' }}
                                    country={merchantApplication?.partner?.countryDetails}
                                />
                                {touched?.totalCardTurnover && errors?.totalCardTurnover && (
                                    <label className="error">{errors.totalCardTurnover}</label>
                                )}
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="flex-start"
                            justifyContent="space-between"
                        >
                            <FormLabel
                                id="averageCardTransaction"
                                htmlFor="averageCardTransaction"
                                sx={{ color: '#1D1D1B', fontSize: '14px', fontWeight: 600 }}
                            >
                                Average Card Transaction Value
                            </FormLabel>
                            <Stack spacing={0.5} style={{ width: '200px', minWidth: '200px' }}>
                                <NPICurrencyInput
                                    onBlur={() => {
                                        return setFieldTouched('averageCardTransaction', true);
                                    }}
                                    name="averageCardTransaction"
                                    handleValue={(countInCents) => {
                                        if (countInCents !== values?.averageCardTransaction) {
                                            setFieldValue('averageCardTransaction', countInCents);
                                        }
                                    }}
                                    defaultValueInCents={values?.averageCardTransaction || 0}
                                    error={
                                        touched?.averageCardTransaction &&
                                        errors?.averageCardTransaction
                                    }
                                    country={merchantApplication?.partner?.countryDetails}
                                    disabled={isEditingDisabled}
                                    style={{ width: '200px', minWidth: '200px' }}
                                />
                                {touched?.averageCardTransaction &&
                                    errors?.averageCardTransaction && (
                                        <label className="error">
                                            {errors.averageCardTransaction}
                                        </label>
                                    )}
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="flex-start"
                            justifyContent="space-between"
                        >
                            <FormLabel
                                id="totalAnnualCompanyTurnover"
                                htmlFor="totalAnnualCompanyTurnover"
                                sx={{ color: '#1D1D1B', fontSize: '14px', fontWeight: 600 }}
                            >
                                Total Annual Company Turnover
                            </FormLabel>
                            <Stack spacing={0.5} style={{ width: '200px', minWidth: '200px' }}>
                                <NPICurrencyInput
                                    name="totalAnnualCompanyTurnover"
                                    handleValue={(countInCents) => {
                                        if (countInCents !== values?.totalAnnualCompanyTurnover) {
                                            setFieldValue(
                                                'totalAnnualCompanyTurnover',
                                                countInCents
                                            );
                                        }
                                    }}
                                    defaultValueInCents={values?.totalAnnualCompanyTurnover || 0}
                                    error={
                                        touched?.totalAnnualCompanyTurnover &&
                                        errors?.totalAnnualCompanyTurnover
                                    }
                                    disabled={isEditingDisabled}
                                    style={{ width: '200px', minWidth: '200px' }}
                                    country={merchantApplication?.partner?.countryDetails}
                                />
                                {touched?.totalAnnualCompanyTurnover &&
                                    errors?.totalAnnualCompanyTurnover && (
                                        <label className="error">
                                            {errors.totalAnnualCompanyTurnover}
                                        </label>
                                    )}
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <FormLabel
                                id="percentageOfCompanyTurnover"
                                sx={{ color: '#1D1D1B', fontSize: '14px', fontWeight: 600 }}
                            >
                                Mail/Telephone Order/E-Commerce Sales (Card not present) as
                                Percentage of Total Card Turnover
                            </FormLabel>
                            <PercentageCounter
                                name="percentageOfCompanyTurnover"
                                label=""
                                boxStyling={{ width: '200px', minWidth: '200px' }}
                                placeholder="%"
                                disabled={isEditingDisabled}
                            />
                        </Stack>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <FormLabel
                                id="percentageViaCard"
                                sx={{ color: '#1D1D1B', fontSize: '14px', fontWeight: 600 }}
                            >
                                Percentage (%) via Card
                            </FormLabel>
                            <PercentageCounter
                                name="percentageViaCard"
                                label=""
                                boxStyling={{ width: '200px', minWidth: '200px' }}
                                placeholder="%"
                                disabled={isEditingDisabled}
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </MainCard>
    );
};
export default CardTurnoverForm;
